<template>
  <section class="px-3 py-5 bg-gray-50 w-98">
    <h1 class="py-3 border-b font-bold">Choose step</h1>

    <div class="space-y-4 my-3">
      <custom-tab :tabs="tabs" @active="active = $event" :current-tab="active" >
        <custom-tab-item :id="botBuilderTabs.BASIC_COMPONENT" :current-tab="active">
          <section class="space-y-3 mt-2">
            <button 
              type="button"
              :draggable="true"
              @dragstart="onDragStart($event, nodeType.SendMessageNode)"
              class="w-full bg-white rounded">
              <div class="flex justify-between px-2 py-4">
                <div class="flex gap-3 items-center">
                  <div class=" bg-primary-950 text-white rounded-md">
                    <Icon icon="iconoir:message" class="font-bold text-lg m-2" />
                  </div>
                  <div class="text-left text-xs">
                    <h1 class="font-semibold text-gray-700">Send Message</h1>
                    <p class="text-gray-400">Plain text, no reply</p>
                  </div>
                </div>
                <div>
                  <Icon icon="mynaui:plus" class="text-xl m-2" />
                </div>
              </div>
            </button>

            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, nodeType.OptionNode)" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="fluent:list-bar-20-regular" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Options</h1>
                      <p class="text-gray-400">Select from a list</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>

            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, nodeType.AskForDetailNode)" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="mingcute:question-line" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Ask for details</h1>
                      <p class="text-gray-400">Get user responses</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>
            
            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, nodeType.ShareLinkNode)" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="mynaui:link" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Share Link</h1>
                      <p class="text-gray-400">Send a link as a messages</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>
          </section>
        </custom-tab-item>
        <custom-tab-item :id="botBuilderTabs.INTEGRATION_COMPONENT" :current-tab="active">
          <section class="space-y-3 mt-2">
            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, nodeType.SetVariableNode)" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="heroicons:variable" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Set Variables</h1>
                      <p class="text-gray-400">Assign a value to a variable</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>

            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, 'input')" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="ant-design:api-outlined" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Call Hook</h1>
                      <p class="text-gray-400">Trigger a specific action</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>

            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, nodeType.ScriptNode)" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="tabler:code" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Script</h1>
                      <p class="text-gray-400">Create a script processes</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>
          </section>
        </custom-tab-item>

        <!-- <custom-tab-item :id="botBuilderTabs.SECURITY_COMPONENT" :current-tab="active">
          <section class="space-y-3 mt-2">
            <button 
                type="button"
                :draggable="true" 
                @dragstart="onDragStart($event, 'start')" 
                class="w-full bg-white rounded-md">
                <div class="flex justify-between px-2 py-4">
                  <div class="flex gap-3 items-center">
                    <div class=" bg-primary-950 text-white rounded-md">
                      <Icon icon="material-symbols-light:identity-platform-outline" class="font-bold text-lg m-2" />
                    </div>
                    <div class="text-left text-xs">
                      <h1 class="font-semibold text-gray-700">Identity Flow</h1>
                      <p class="text-gray-400">Identify your users...</p>
                    </div>
                  </div>
                  <div>
                    <Icon icon="mynaui:plus" class="text-xl m-2" />
                  </div>
                </div>
            </button>
          </section>
        </custom-tab-item> -->
      </custom-tab>     
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import { Icon } from "@iconify/vue";
import { botBuilderTabs } from "@/core/helper/enums/tab/botBuilderTabs";
import { nodeType } from '@/core/helper/enums/nodeType'
import CustomTab from './CustomTab.vue';
import CustomTabItem from './CustomTabItem.vue';

const active = ref(botBuilderTabs.BASIC_COMPONENT);
const tabs = ref([
{
    id: botBuilderTabs.BASIC_COMPONENT,
    title: 'Basics'
},
{
    id: botBuilderTabs.INTEGRATION_COMPONENT,
    title: 'Integrations'
},
]);


const onDragStart = (event, nodeType) => {
  if (event.dataTransfer) {
    event.dataTransfer.setData('application/vueflow', nodeType)
    event.dataTransfer.effectAllowed = 'move'
  }
}
</script>